import type { ComponentProps } from "react"
import { forwardRef } from "react"

export const SlaIcon = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
	({ className, ...props }, ref) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="currentColor"
			ref={ref}
			{...props}
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.80596 1.18963C10 0.467371 9.5 1.97074 9.5 2.97299C9.5 3.97525 10.5 5.45947 11 5.97974C11.5 6.5 12 6.98199 12 6.98199C12.8575 7.87856 13 8.98398 13 9.98874V10.0159C13 12.7685 10.7614 15 8 15C5.23858 15 3 12.7685 3 10.0159C3 9 3.31522 8.48521 3.25 7.5C3.21077 6.90743 3 6.5 3 6C3 5.15486 4.34867 5.95895 5 6.5L6 7.45656V5.53023C6 4.11834 6.66687 2.78883 7.8 1.94169L8.80596 1.18963ZM8 13.9978C9.25 13.9978 10.5 13.5604 10.5 11.811C10.5 10.4429 9.48069 9.09715 8.63778 8.40117C8.35964 8.17151 8 8.38851 8 8.74969V10.4989C8 10.8601 7.63032 11.1027 7.30003 10.9582L6.19997 10.4771C5.86968 10.3327 5.49618 10.5754 5.51681 10.936C5.58908 12.1989 5.9719 13.9978 8 13.9978Z"
			/>
		</svg>
	),
)
